import React, { useState, useEffect, useRef, use } from 'react';
import { FaHome, FaUserCircle , FaSignOutAlt} from 'react-icons/fa'; // Importing icons
import logo from '../assets/logo192.png';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { setUserDetails } from '../redux/userSlice';
import ProfileModal from './ProfileModal';
import api from '../api/api';
import useProfileStore from '../Zustand/useProfileStore';
import HelpIcon from '@mui/icons-material/Help';
const MainHeader = () => {
    const [isProfileMenuOpen, setProfileMenuOpen] = useState(false);
    const profileMenuRef = useRef(null); // Ref for the profile menu
    const [showModal, setShowModal] = useState(false);
    const imageUrl = useProfileStore((state) => state.imageUrl);
    const setImageUrl = useProfileStore((state) => state.setImageUrl);
    const navigate = useNavigate();
      const user = useSelector(state => state.user.userDetails);
        const [token, setToken] = useState(null);
    const dispatch = useDispatch();
  const location =useLocation()
    const handleLogout = () => {
      sessionStorage.removeItem('accessToken'); // Clear the token
      dispatch(setUserDetails(null));         // Optional: Clear user data in redux
      navigate('/');                          // Redirect to login or home
    };
 useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const accessToken = queryParams.get('allow');

    if (accessToken) {
      setToken(accessToken);

    }
  }, [location.search]);
  // ✅ Fetch latest profile image with cache-busting
const checkProfileImage = (userId) => {
  const cacheBuster = new Date().getTime();
  const profileImgUrl = `https://hub2.ntactops.com/ntact/files/user_profiles/${userId}_profile.png?cb=${cacheBuster}`;
  const img = new Image();

  img.onload = () => setImageUrl(profileImgUrl);
  img.onerror = () => setImageUrl(null);
  img.src = profileImgUrl;
};
useEffect(() => {
  if (user?.id) {
    checkProfileImage(user.id);
  }
}, [user,]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (profileMenuRef.current && !profileMenuRef.current.contains(event.target)) {
                setProfileMenuOpen(false); // Close menu if clicked outside
            }
        };

        // Add event listener
        document.addEventListener('mousedown', handleClickOutside);

        // Cleanup the event listener on component unmount
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const toggleProfileMenu = () => {
        setProfileMenuOpen((prev) => !prev); // Toggle the dropdown menu
    };
    


    return (
        <header className="flex items-center justify-between p-4 border-b border-gray-300 bg-[#FFFFFF]">
            <div className='flex'>
                <img   onClick={() => {
    if (!token){

       if(user?.role==1){
     navigate('/home');
        }else if(user?.role==2){
  navigate('/dashboard');
        }else{
 navigate('/dashboard');

        }
    } ;
  }}src={logo} alt="Logo" className="w-16 cursor-pointer h-12 mr-4" />
                {location.pathname.includes('/timesheet') && (
        <h1 className="text-[18px] font-bold text-black">Employee Timesheet</h1>
      )}
            </div>
            <div className='flex gap-4 items-center'>
                {/* Home Icon */}
                <HelpIcon 
                sx={{width:"20px"}}
              className={`text-gray-500  cursor-pointer mr-4 ${token ? 'opacity-50 cursor-not-allowed' : ''}`}
                onClick={()=>{
                  navigate('/support')
                }}
                />
             <FaHome
  onClick={() => {
 if (!token){

       if(user?.role==1){
     navigate('/home');
        }else if(user?.role==2){
  navigate('/dashboard');
        }else{
 navigate('/dashboard');

        }
    }
  }}
  className={`text-gray-500 cursor-pointer mr-4 ${token ? 'opacity-50 cursor-not-allowed' : ''}`}
  size={20}
/>
                
                {/* Profile Icon with Dropdown */}
                <div className="relative">
           {imageUrl ? (
  <div className="rounded-full cursor-pointer border-2 border-gray-300 w-8 h-8 overflow-hidden">
    <img
      onClick={toggleProfileMenu}
      src={imageUrl}
      alt="Profile"
      className="w-full h-full object-cover"
    />
  </div>
) : (
  <FaUserCircle
    className="text-gray-500 cursor-pointer"
    size={24}
    onClick={toggleProfileMenu} // <- Add this line
  />
)}


                    {isProfileMenuOpen && (
                        <div 
                            ref={profileMenuRef} // Attach the ref to the dropdown
                            className="absolute right-0 mt-2 p-2 w-36 z-20 bg-white shadow-lg rounded-md border border-gray-300"
                        >
                    <button
  className={`block w-full flex items-center gap-2 text-left p-2 ${
    token ? 'text-gray-400 cursor-not-allowed' : 'text-black hover:bg-gray-200'
  }`}
  onClick={() => {
    if (!token) {
      // setShowModal(true);
      navigate('./profile');
    }
  }}
  disabled={!!token}  // optional: disables the button for accessibility
>
  <FaUserCircle
    className={`text-gray-500 ${token ? 'opacity-50' : ''}`}
    size={18}
  /> 
  Profile
</button>
                            <button
                                className="block w-full flex items-center gap-2 text-left p-2 text-black hover:bg-gray-200"
                                onClick={handleLogout}
                            >
                                  <FaSignOutAlt  className="text-gray-500  cursor-pointer" size={16} />
                                Logout
                            </button>
                        </div>
                    )}
                </div>
            </div>
            <ProfileModal isOpen={showModal} onClose={() => setShowModal(false)} />
        </header>
    );
};

export default MainHeader;
